module.exports = __webpack_public_path__ + "static/media/gb12.001fdf07.png";